import { QuizzesResponse } from '../types';

export function concatQuizAndFolders(quizResponse: QuizzesResponse) {
  const quizzes = (quizResponse.quizzes ?? []).map(({ id, ...quiz }) => ({
    id,
    ...quiz,
    type: 'quiz' as const,
  }));

  const folders = (quizResponse.folders ?? []).map(({ id, ...folder }) => ({
    id,
    ...folder,
    type: 'folder' as const,
  }));

  return [...quizzes, ...folders];
}
